import styled from 'styled-components';
import { Button, Modal, Row, Col, Card } from 'antd';

export const ModalStyled = styled(Modal)`
	.ant-modal-content {
		padding: 30px 0;
		border-radius: 30px;
		min-width: 400px;
		max-width: 900px;
		max-height: 720px;
		height: auto;
	}

	.ant-modal-title {
		font-size: 1.4rem !important;
	}

	.ant-typography {
		font-size: 1.563rem !important;
		line-height: 2rem !important;
		letter-spacing: -0.5% !important;
		font-weight: 600 !important;
		color: #262626 !important;
	}

	.ant-modal-footer {
		justify-content: center;
		align-items: center;
		display: flex;
	}

	.ant-modal-header {
		padding: 5px 25px !important;
	}

	.ant-btn-primary {
		background-color: #002fbb;
		height: 2.5rem !important;
	}

	.ant-btn-primary:hover {
		background-color: rgba(0, 47, 187, 0.75);
	}
	.ant-btn-ghost {
		background-color: #fff;
		height: 2.5rem !important;
	}
`;

export const SmallModalStyled = styled(Modal)`
	.ant-modal-content {
		border-radius: 24px;
		height: auto;
		gap: 24px;
	}

	.ant-modal-title {
		font-size: 1.4rem !important;
	}

	.ant-typography {
		font-size: 1.563rem !important;
		line-height: 2rem !important;
		letter-spacing: -0.5% !important;
		font-weight: 600 !important;
		color: #262626 !important;
	}

	.ant-modal-footer {
		justify-content: center;
		align-items: center;
		display: flex;
	}

	.ant-modal-header {
		padding: 5px 25px !important;
	}

	.ant-btn-primary {
		background-color: #002fbb;
		height: 2.5rem !important;
	}

	.ant-btn-primary:hover {
		background-color: rgba(0, 47, 187, 0.75);
	}
	.ant-btn-ghost {
		background-color: #fff;
		height: 2.5rem !important;
	}

	@media (max-width: 768px) {
		.ant-modal-content {
			margin-top: 10rem;
			box-shadow: none;
		}
	}
`;

export const ModalContent = styled(Row)`
	max-height: 200px;
	height: auto;
	overflow-y: auto;

	::-webkit-scrollbar {
		width: 4px;
		background: transparent;
	}

	::-webkit-scrollbar-track {
		border-radius: 2px;
	}

	::-webkit-scrollbar-thumb {
		background: #e6e6e6;
		border-radius: 2px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;

export const CustomCol = styled(Col)`
	text-align: center;
	width: 336px;
	height: 25px;
	margin-top: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const AlertContentText = styled.span`
	font-size: 1.2rem !important;
	line-height: 1.5rem !important;
	letter-spacing: -0.5% !important;
	font-weight: 400 !important;
	color: #262626 !important;
`;

export const RoundButton = styled(Button)`
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	letter-spacing: -0.5%;
	border-radius: 4px;
	width: 5rem !important;
	height: 2.5rem !important;
	gap: 0.25rem;
	padding: 0.5rem;
	background-color: #002fbb;
`;

export const SummaryText = styled.p`
	font-size: 14px;
	color: #666;
	margin-bottom: 16px;
	text-align: left;
`;

export const QuestionsList = styled.div`
	padding-right: 8px;
	margin-bottom: 16px;
`;

export interface QuestionItemProps {
	answered: boolean;
}

export const QuestionItem = styled.div<QuestionItemProps>`
	padding: 12px 8px;
	margin-bottom: 6px;
	cursor: pointer;
	border-radius: 6px;
	transition: all 0.3s ease;
	background-color: ${(props) => (props.answered ? '#f6ffed' : '#fff1f0')};
	border-left: 3px solid ${(props) => (props.answered ? '#52c41a' : '#ff4d4f')};

	&:hover {
		background-color: ${(props) => (props.answered ? '#d9f7be' : '#ffccc7')};
	}
`;

export const SimpleQuestionItem = styled.div`
	padding: 12px 8px;
	margin-bottom: 6px;
	cursor: pointer;
	border-radius: 6px;
	transition: all 0.3s ease;

	&:hover {
		background-color: #f5f5f5;
	}
`;

export const QuestionTitle = styled.div`
	font-weight: 600;
	font-size: 15px;
	color: #262626;
	margin-bottom: 6px;
`;

export const AnswerText = styled.div`
	margin-top: 8px;
	font-size: 14px;
	color: #595959;
`;

export const QuestionDescription = styled.div`
	font-size: 14px;
	color: #595959;
	margin-bottom: 6px;
`;

export const FloatingScrollButton = styled.button`
	position: fixed;
	right: 32px;
	bottom: 32px;
	z-index: 2000;
	background: rgba(230, 234, 248, 1);
	border: none;
	border-radius: 50%;
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(38, 38, 38, 1);
	cursor: pointer;

	@media (max-width: 600px) {
		right: 16px;
		bottom: 16px;
		width: 40px;
		height: 40px;
	}
`;

export const StyledCard = styled(Card)`
	margin-bottom: 16px;
	padding: 16px;
	border-radius: 24px;
	width: 70%;

	@media (max-width: 768px) {
		width: 100%;
		padding-left: 15px;
		padding-right: 15px;

		.ant-card-body {
			padding: 0 !important;
		}
	}
`;

export const CenteredCol = styled(Col)`
	display: flex;
	justify-content: center;
`;
